import { useContext, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { AuthContext } from "../../../context/AuthContext";
import { ErrorContext } from "../../../context/ErrorContext";
import { LicenseType } from "../../../collector";
import Switch from "../../../components/Switch/Switch";
import EnabledLabel from "../../../components/EnabledLabel";

interface CreateBulkRangeProps {
    createdBulkRange: () => void;
    environment: string;
}

export default function CreateBulkRangeModal(props: CreateBulkRangeProps) {

    const [discountPercentage, setDiscountPercentage] = useState<number>(0);
    const [delimiter, setDelimiter] = useState<number>(2);
    const [productType, setProductType] = useState<LicenseType>(LicenseType.Pro);
    const [enabled, setEnabled] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);

    const { showErrorModal } = useContext(ErrorContext);
    const { token, invalidWSToken } = useContext(AuthContext);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setDelimiter(2);
        setDiscountPercentage(0);
        setProductType(LicenseType.Pro);
        setEnabled(false);
    };

    const createBulkRange = async () => {
        try {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token(),
                },
                body: JSON.stringify({
                    'delimiter': delimiter,
                    'value': discountPercentage,
                    'product_id': productType,
                    'enabled': enabled
                })
            }
            await fetch(props.environment + 'createBulkRange', requestOptions)
                .then((res) => {
                    if (!res.ok) {
                        throw new Error("Failed to create bulk range");
                    }
                    return res.json();
                })
                .then(() => {
                    props.createdBulkRange();
                    handleClose();
                });
        } catch (error: any) {
            showErrorModal(error ?? "Failed to create bulk range - Server is unavailable at the moment");
        }
    }

    return (
        <>
            <Button variant='outline-dark' disabled={invalidWSToken(props.environment)} onClick={() => handleShow()}>
                Create Bulk Range
            </Button>
            {show && !invalidWSToken(props.environment) &&
                <Modal
                    show={show}
                    backdrop="static"
                    onHide={() => handleClose()}
                    keyboard={false}
                >
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        createBulkRange();
                    }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Create Bulk Range</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="dialog-data-field">
                                <span>Product:</span>
                                <select value={productType} required onChange={(item) => setProductType(Number(item.target.value))} >
                                    <option value={LicenseType.Pro}>DOTE Pro</option>
                                    <option value={LicenseType.ProCommunity}>DOTE Pro Community</option>
                                    <option value={LicenseType.SiteLicense}>Site-License</option>
                                </select>
                            </div>
                            <div className="dialog-data-field">
                                <span>Delimiter:</span>
                                <input type="number" min={2} value={delimiter} required
                                    onChange={(item) => setDelimiter(Number(item.target.value))} />
                            </div>
                            <div className="dialog-data-field">
                                <span>Discount Value (%):</span>
                                <input min={0} max={99} type='number' value={discountPercentage} required
                                    onChange={(item) => setDiscountPercentage(Number(item.target.value))}
                                />
                            </div>
                            <div className="dialog-data-field">
                                <span>Enabled:</span>
                                <Switch checked={enabled} onChange={(item) => setEnabled(item.target.checked)} />
                            </div>
                            <div className="text-end-container">
                                <EnabledLabel enabled={enabled} />
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => handleClose()}>
                                Close
                            </Button>
                            <Button variant="primary" type='submit'>Create Bulk Range</Button>
                        </Modal.Footer>
                    </form>
                </Modal>}
        </>
    );
}
